
(function(template){
define('vue!loginVueApp/pages/CreateUserPage',[
  'Vue',
  'helpers',
  'vue!loginVueApp/components/Dropdown',
  'vue!loginVueApp/components/Input',
], function (Vue, helpers, dropdown, inputField) {
  return {
    name: 'CreateUserPage',
    template: template,
    components: {
      dropdown: dropdown,
      'input-field': inputField,
    },
    data: function () {
      return {
        email: '',
        password: '',
        confirmPw: '',
        gender: '',
        salutation: '',
        firstName: '',
        lastName: '',
        phoneType: '',
        homePhone: '',
        workPhone: '',
        workExt: '',
        otherPhone: '',
        mobilePhone: '',
        addressFirst: '',
        addressSecond: '',
        city: '',
        province: '',
        country: '',
        postalCode: '',
        newsLetter: '',
        mailMarketing: '',
        phoneMarketing: '',
        smsMarketing: '',
        language: '',
        dob: null,
        checkedPromos: [],
        selectedGender: '',
        isGuestUser: false,
        isValidEmail: false,
        emailExists: false,
        emailError: '',
        passwordErr: '',
        progressHelperText: '',
        passwordStrengthDiff: '',
        error: '',
      };
    },
    computed: {
      enableRegisterBtn: function () {
        if(this.isGuestUser){
          return true;
        }
        return this.passwordStrengthDiff <= 0  && this.password.length >= 8;
      },
      promotions: function () {
        return [
          {
            name: app.localization.newUser.subscribeNewsletter,
            val: 'email',
            show: app.customization.defaultMarketingOptIn
          },
          {
            name: app.localization.newUser.subscribeMailMarketing,
            val: 'news',
            show: app.customization.showMailMarketing
          },
          {
            name: app.localization.newUser.subscribeSMSMarketing,
            val: 'sms',
            show: app.customization.showSMSMarketing
          },
          {
            name: app.localization.newUser.subscribePhoneMarketing,
            val: 'phone',
            show: app.customization.showPhoneMarketing
          },
        ];
      },
      salutations: function () {
        var salutationsObj = {};
        salutationsObj[app.localization.general.salutation.notSpecified] = '';
        salutationsObj[app.localization.general.salutation.mister] = 'Mr.';
        salutationsObj[app.localization.general.salutation.miss] = 'Miss.';
        salutationsObj[app.localization.general.salutation.mizz] = 'Ms.';
        salutationsObj[app.localization.general.salutation.misterAndMissus] =
          'Mrs.';
        salutationsObj[app.localization.general.salutation.doctor] = 'Dr.';
        salutationsObj[app.localization.general.salutation.misterAndMissus] =
          'MrMrs';
        return helpers.getOptions(salutationsObj);
      },
      genders: function () {
        var genderOptions = {};

        genderOptions[app.localization.newUser.genderTitle] = '';
        genderOptions.Male = 'M';
        genderOptions.Female = 'F';
        genderOptions.Other = 'O';

        return helpers.getOptions(genderOptions);
      },
      phones: function () {
        return helpers.getOptions({
          'Select Phone Type': '',
          Home: 'HOME',
          Work: 'WORK',
          Other: 'OTHER',
          Mobile: 'MOBILE',
        });
      },
      languages: function () {
        return helpers.getOptions({
          English: 'English',
          French: 'French',
          Spanish: 'Spanish',
          Chinese: 'Chinese',
        });
      },
      provinces: function () {
        var provinces = { 'Select Province': '' };
        _.each(app.localization.stateList, function (state) {
          provinces[state.name] = state.code;
        });
        return helpers.getOptions(provinces);
      },
      countries: function () {
        var countries = { 'Select Country': '' };
        _.each(app.localization.countryList, function (state) {
          countries[state.name] = state.name;
        });
        return helpers.getOptions(countries);
      },
    },
    beforeMount: function () {
      this.email = this.$store.state.isValidEmail;
    },
    mounted: function () {
      this.isGuestUser =
        this.$store.state.currentRoute === 'guest' ||
        window.location.hash.indexOf('guest') !== -1;
    },
    methods: {
      handleSubmit: function () {
        if (!this.isValidEmail) {
          this.emailError = app.localization.loginVue.invalidFormat;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (this.emailExists && !this.isGuestUser) {
          this.emailError = app.localization.loginVue.exists;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (this.password !== this.confirmPw) {
          this.passwordErr = app.localization.loginVue.noMatch;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else if (parseFloat(this.passwordStrengthDiff) > 0) {
          this.passwordErr = app.localization.loginVue.notStrong;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          helpers.createUser(this.$data, this.isGuestUser);
        }
      },
      validateEmail: function () {
        var vm = this;
        if (helpers.validEmail(this.email)) {
          vm.isValidEmail = true;
          if (!this.isGuestUser) {
            helpers.checkEmail(this.email).then(function (emailExists) {
              vm.emailExists = emailExists;
            });
          }
        } else {
          vm.isValidEmail = false;
        }
      },
      removeError: function () {
        this.error = '';
      },
      checkPhoneTypeRequired: function(requiredPhoneTypes, phoneType) {
       
        requiredPhoneTypes = requiredPhoneTypes.map(function (type) {
          return type.toLowerCase();
        });
        return requiredPhoneTypes.indexOf(phoneType) !== -1;
      },
    },
    watch: {
      password: function (passwordVal) {
        var vm = this;
        helpers
          .performPasswordComplexityCheck(passwordVal)
          .then(function (diff, progressHelperText) {
            vm.progressHelperText = progressHelperText;
            vm.passwordStrengthDiff = diff + '';
          });
      },
      confirmPw: function (val) {
        var vm = this;
        function showPwErr() {
          if (vm.password !== val) {
            vm.passwordErr = app.localization.loginVue.noMatch;
          } else {
            vm.passwordErr = '';
          }
        }
        var showPwErrDelayed = _.debounce(showPwErr, 1000);
        showPwErrDelayed();
      },
      email: function (val) {
        var lazyValidate = _.debounce(this.validateEmail, 500);
        lazyValidate();
      },
      checkedPromos: function (val) {
        this.newsLetter = val.indexOf('news') !== -1 ? 'Y' : 'N';
        this.mailMarketing = val.indexOf('email') !== -1 ? 'Y' : 'N';
        this.phoneMarketing = val.indexOf('phone') !== -1 ? 'Y' : 'N';
        this.smsMarketing = val.indexOf('sms') !== -1 ? 'Y' : 'N';
      },
    },
  };
});
})('<div class=""> <div class="headers"> <h2 v-if="isGuestUser">{{ localization.loginVue.guestAcctHeader }}</h2> <h2 v-if="!isGuestUser">{{ localization.loginVue.userAcctHeader }}</h2> <h4>{{localization.loginVue.formPrompt}}</h4> </div> <div id="create-page"> <form class="create-user" @submit.prevent="handleSubmit"> <div v-if="error" v-click-outside="hide" role="alert" class="error-message" > <p>{{ error }}</p> <button @click.prevent="removeError" class="close">X</button> </div> <div class="create-password"> <h4 v-if="isGuestUser">Email</h4> <div class="email-val"> <input-field :text.sync="email" id="new-email" name="email" type="email" :labelName="localization.loginVue.email" isRequired="true" :initValue="email" :disableField="!isGuestUser" ></input-field> <div class="" v-if="!isGuestUser"> <a class="edit-email" href="#/profile/login"><i class="icon-pencil"></i></a> </div> </div> <div v-if="!isValidEmail || emailExists" class="vue-error"> {{ emailError }} </div> <div v-if="!isGuestUser" class="passwords"> <div class=""> <input-field :text.sync="password" id="new-password" name="password" type="password" :labelName="localization.loginVue.password" :isRequired="!isGuestUser" ></input-field> <div v-if="password" class="passwordComplexityUI"> <span v-if="progressHelperText" :class="{ \'vue-error\': passwordStrengthDiff == \'1000\', \'vue-warning\':passwordStrengthDiff < 4 && passwordStrengthDiff > 0, \'vue-success\': passwordStrengthDiff <= 0 }"> {{ progressHelperText }} </span> <div class="progress password-progress"> <div id="password-strength-meter" class="progress-bar" role="progressbar" style="width: 0" ></div> </div> </div> </div> <div class=""> <input-field :text.sync="confirmPw" id="confirm-password" name="confirm-password" type="password" :labelName="localization.loginVue.cPassword" :isRequired="!isGuestUser" ></input-field> <div v-if="confirmPw && passwordErr" class="vue-error"> {{ passwordErr }} </div> </div> </div> </div> <div class="guest-info"> <h4>{{ localization.loginVue.guestInfo }}</h4> <div class="guest-sal"> <dropdown v-if="isGuestUser ? requireOrShowFields.salutation.show.guest : requireOrShowFields.salutation.show.newAccount" :isRequired="isGuestUser ? requireOrShowFields.salutation.require.guest : requireOrShowFields.salutation.require.newAccount" :labelName="localization.loginVue.salutation" :options="salutations" :selected.sync="salutation" ></dropdown> <dropdown v-if="isGuestUser ? requireOrShowFields.gender.show.guest : requireOrShowFields.gender.show.newAccount" :isRequired="isGuestUser ? requireOrShowFields.gender.require.guest : requireOrShowFields.gender.require.newAccount" :options="genders" :selected.sync="gender" :selectedGender="selectedGender" :labelName="localization.loginVue.gender" ></dropdown> <input-field v-if="isGuestUser ? requireOrShowFields.dateOfBirth.show.guest : requireOrShowFields.dateOfBirth.show.newAccount" :isRequired="isGuestUser ? requireOrShowFields.dateOfBirth.require.guest : requireOrShowFields.dateOfBirth.require.newAccount" :text.sync="dob" id="dob" name="dob" type="date" :labelName="localization.loginVue.dob" ></input-field> </div> <div class="guest-name"> <input-field :text.sync="firstName" id="first-name" name="first-name" type="text" :labelName="localization.loginVue.first" isRequired="true" ></input-field> <input-field :text.sync="lastName" id="last-name" name="last-name" type="text" :labelName="localization.loginVue.last" isRequired="true" ></input-field> </div> </div> <div class="contact-info" v-if="isGuestUser ? requireOrShowFields.phone.show.guest : requireOrShowFields.phone.show.newAccount "> <div class=""> <h4>{{ localization.loginVue.contactInfo }}</h4> <div v-if="isGuestUser ? !requireOrShowFields.phone.require.guestRequiredPhoneTypes.length : !requireOrShowFields.phone.require.newAccountRequiredPhoneTypes.length " id="dropdownWrap"> <dropdown :labelName="localization.loginVue.pType" :options="phones" :selected.sync="phoneType" ></dropdown> <input-field v-if="phoneType === \'HOME\'" :text.sync="homePhone" id="home-number" name="home-number" type="text" :labelName="localization.loginVue.home" :isRequired="phoneType === \'HOME\'" ></input-field> <div v-if="phoneType === \'WORK\'" class=""> <input-field :text.sync="workExt" id="work-ext-number" name="work-ext-number" type="text" :labelName="localization.loginVue.workExt" ></input-field> <input-field :text.sync="workPhone" id="work-number" name="work-number" type="text" :labelName="localization.loginVue.work" :isRequired="phoneType === \'WORK\'" ></input-field> </div> <input-field v-if="phoneType === \'OTHER\'" :text.sync="otherPhone" id="other-number" name="other-number" type="text" :labelName="localization.loginVue.other" :isRequired="phoneType === \'OTHER\'" ></input-field> <input-field v-if="phoneType === \'MOBILE\'" :text.sync="mobilePhone" id="mobile-number" name="mobile-number" type="text" :labelName="localization.loginVue.mobile" :isRequired="phoneType === \'MOBILE\'" ></input-field> </div> <div v-if="isGuestUser ? requireOrShowFields.phone.require.guestRequiredPhoneTypes.length : requireOrShowFields.phone.require.newAccountRequiredPhoneTypes.length " id="phoneTypesWrap"> <input-field :isRequired="isGuestUser ? checkPhoneTypeRequired(requireOrShowFields.phone.require.guestRequiredPhoneTypes, \'home\') : checkPhoneTypeRequired(requireOrShowFields.phone.require.newAccountRequiredPhoneTypes, \'home\') " id="home-number" name="home-number" type="text" :labelName="localization.loginVue.home" :text.sync="homePhone" ></input-field> <div id="workPhoneWrap"> <input-field :isRequired="isGuestUser ? checkPhoneTypeRequired(requireOrShowFields.phone.require.guestRequiredPhoneTypes, \'work\') : checkPhoneTypeRequired(requireOrShowFields.phone.require.newAccountRequiredPhoneTypes, \'work\') " id="work-number" name="work-number" type="text" :labelName="localization.loginVue.work" :text.sync="workPhone" ></input-field> <input-field :text.sync="workExt" id="work-ext-number" name="work-ext-number" type="text" :labelName="localization.newUser.workPhoneExtension" class="work-ext" ></input-field> </div> <input-field :isRequired="isGuestUser ? checkPhoneTypeRequired(requireOrShowFields.phone.require.guestRequiredPhoneTypes, \'other\') : checkPhoneTypeRequired(requireOrShowFields.phone.require.newAccountRequiredPhoneTypes, \'other\') " id="other-number" name="other-number" type="text" :labelName="localization.loginVue.other" :text.sync="otherPhone" ></input-field> <input-field :isRequired="isGuestUser ? checkPhoneTypeRequired(requireOrShowFields.phone.require.guestRequiredPhoneTypes, \'mobile\') : checkPhoneTypeRequired(requireOrShowFields.phone.require.newAccountRequiredPhoneTypes, \'mobile\') " id="mobile-number" name="mobile-number" type="text" :labelName="localization.loginVue.mobile" :text.sync="mobilePhone" ></input-field> </div> </div> </div> <div class="address" v-if="(isGuestUser ? requireOrShowFields.address.show.guest : requireOrShowFields.address.show.newAccount )"> <h4>{{(isGuestUser ? requireOrShowFields.address.show.guest : requireOrShowFields.address.show.newAccount ) ? localization.loginVue.homeAddress + \'*\' : localization.loginVue.homeAddress }}</h4> <div class="addresses-div"> <input-field v-if="isGuestUser ? requireOrShowFields.addressFirst.show.guest : requireOrShowFields.addressFirst.show.newAccount " :isRequired="isGuestUser ? requireOrShowFields.addressFirst.require.guest : requireOrShowFields.addressFirst.require.newAccount " id="addressFirst" name="addressFirst" type="text" :labelName="localization.loginVue.addressOne" ></input-field> <input-field v-if="isGuestUser ? requireOrShowFields.addressSecond.show.guest : requireOrShowFields.addressSecond.show.newAccount " :isRequired="isGuestUser ? requireOrShowFields.addressSecond.require.guest : requireOrShowFields.addressSecond.require.newAccount " :text.sync="addressSecond" id="addressSecond" name="addressSecond" type="text" :labelName="localization.loginVue.addressTwo" ></input-field> </div> <div class="location-div"> <input-field v-if="isGuestUser ? requireOrShowFields.city.show.guest : requireOrShowFields.city.show.newAccount " :isRequired="isGuestUser ? requireOrShowFields.city.require.guest : requireOrShowFields.city.require.newAccount " :text.sync="city" id="city" name="city" type="text" :labelName="localization.loginVue.city" ></input-field> <dropdown v-if="isGuestUser ? requireOrShowFields.province.show.guest : requireOrShowFields.province.show.newAccount " :isRequired="isGuestUser ? requireOrShowFields.province.require.guest : requireOrShowFields.province.require.newAccount " :options="provinces" :labelName="localization.loginVue.province" :selected.sync="province" ></dropdown> </div> <div class="postal"> <input-field v-if="isGuestUser ? requireOrShowFields.postalCode.show.guest : requireOrShowFields.postalCode.show.newAccount" :isRequired="isGuestUser ? requireOrShowFields.postalCode.require.guest : requireOrShowFields.postalCode.require.newAccount" :text.sync="postalCode" id="address-postal" name="address-postal" type="text" :labelName="localization.loginVue.postal" ></input-field> <dropdown v-if="isGuestUser ? requireOrShowFields.country.show.guest : requireOrShowFields.country.show.newAccount" :isRequired="isGuestUser ? requireOrShowFields.country.require.guest : requireOrShowFields.country.require.newAccount" :options="countries" :labelName="localization.loginVue.country" :selected.sync="country" ></dropdown> </div> </div> <div class="language-div" v-if="isGuestUser ? requireOrShowFields.language.show.guest : requireOrShowFields.language.show.newAccount"> <div class=""> <h4>{{localization.loginVue.lang}}</h4> <dropdown :options="languages" :selected.sync="language" :labelName="localization.loginVue.lang" ></dropdown> </div> </div> <div class="promoitions-div" v-if="isGuestUser ? requireOrShowFields.promotions.show.guest : requireOrShowFields.promotions.show.newAccount"> <h4>{{ localization.loginVue.promotions }}</h4> <div v-for="(promo, index) in promotions" class="optional-promos" v-bind:key="promo.name" > <div class="" v-if="promo.show"> <input type="checkbox" :id="promo.val + index" :value="promo.val" v-model="checkedPromos" /> <label :for="promo.val + index"> <span>{{ promo.name }}</span> </label> </div> </div> </div> <div class="register-btn"> <button class="btn btn-primary pull-right" :class="{\'disabled\':!enableRegisterBtn}" type="submit"> {{ localization.loginVue.registerBtn }} </button> </div> </form> </div> </div>');
